import { TAuthTypes } from 'src/types';

export interface IBrandResponse {
  brand_id: string;
  logo_url: string | null;
  name: string;
  channels: IChannelResponse[];
  venues: number;
  display_order: number;
  configured_addons: IConfiguredAddons[];
}

export interface IChannelResponse {
  channel_id: string;
  logo_url: string;
  name: string;
}

export interface IConfiguredAddonEndpoint {
  endpoint_id: string;
  name: string;
  override_url: string | null;
}

export const CONFIG_FIELD_TYPES = [
  'string',
  'multiline',
  'number',
  'boolean',
  'secret',
  'select',
] as const;
export type TConfigFieldType = (typeof CONFIG_FIELD_TYPES)[number];

export interface IConfigSchemaField {
  key: string;
  label: string;
  type: string;
  required?: boolean;
  options?: string[];
  default?: string | number | boolean;
  placeholder?: string;
  order?: number;
}

export interface IConfiguredAddons {
  configuration_id: string;
  addon_id: string;
  addon_name: string;
  preferred_name: string;
  username: string | null;
  authentication_type: TAuthTypes | null;
  password?: string;
  access_token?: string;
  contents?: string;
  external_id: string | null;
  endpoints?: IConfiguredAddonEndpoint[];
  config?: Record<string, string | number | boolean>;
}
